import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import { FaWifi, FaTv, FaSnowflake, FaUtensils, FaBath } from 'react-icons/fa';
import { MdLandscape } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HotelDetail = () => {
    const { id, date } = useParams();

    const [room, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_ROOM = "api/staynest/mobile/Rooms/detail";

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data;
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_ROOM}?id=${id}&date=${date}`).then((data) => {
            setData(data);
            setLoading(false);
        });
    }, [id]);

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
    };

    if (loading) return <div className="p-6 text-center">Loading...</div>;
    if (error) return <div className="p-6 text-center text-red-500">{error}</div>;

    return (
        <div className="p-6 space-y-16 bg-gradient-to-b from-indigo-50 to-white min-h-screen">
            <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">

                {/* Image Slider */}
                <Slider {...sliderSettings}>
                    {room._photos?.map((photo, index) => (
                        <div key={index}>
                            <img
                                src={`${BASE_URL}/upload/staynest/${photo.photo_url}`}
                                alt={`Room photo ${index + 1}`}
                                className="w-full h-96 object-cover"
                            />
                        </div>
                    ))}
                </Slider>

                {/* Room Info */}
                <div className="p-6">
                    <h1 className="text-3xl font-bold text-gray-800 mb-2">{room.room_name}</h1>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700 mb-4">
                        <p><strong>Property Type:</strong> {room.property_type}</p>
                        <p><strong>Room Type:</strong> {room.room_type}</p>
                        <p><strong>Bed Type:</strong> {room.bed_type}</p>
                        <p><strong>Capacity:</strong> {room.capacity} person(s)</p>
                    </div>

                    {/* Facilities */}
                    <div className="mb-6">
                        <h2 className="text-lg font-semibold text-gray-800 mb-2">Facilities</h2>
                        <div className="flex flex-wrap gap-4 text-gray-600">
                            {room._facilites?.includes('Sarapan') && <div className="flex items-center gap-1"><FaUtensils /> Sarapan</div>}
                            {room._facilites?.includes('Kamar Mandi Dalam') && <div className="flex items-center gap-1"><FaBath /> Kamar Mandi Dalam</div>}
                            {room._facilites?.includes('AC') && <div className="flex items-center gap-1"><FaSnowflake /> AC</div>}
                            {room._facilites?.includes('Wi-Fi') && <div className="flex items-center gap-1"><FaWifi /> Wi-Fi</div>}
                            {room._facilites?.includes('TV') && <div className="flex items-center gap-1"><FaTv /> TV</div>}
                            {room._facilites?.includes('Balkon') && <div className="flex items-center gap-1"><MdLandscape /> Balkon</div>}
                        </div>
                    </div>

                    <div className="text-2xl font-bold text-indigo-600">
                        Rp {Number(room._current_price).toLocaleString('id-ID')}/malam
                    </div>

                    <p className="text-lg text-gray-700 leading-relaxed">
                        <div dangerouslySetInnerHTML={{ __html: room.description }} />
                    </p>
                </div>
            </div>
        </div>
    );
};

export default HotelDetail;